import React from "react";
import { createPortal } from "react-dom";
import CloseIcon from "@mui/icons-material/Close";

import "../../styles/common/popup.scss";
import "../../styles/common/evalScoreDetailsPopup.scss";

const EvalScoreDetailsPopup = ({ open, onClose, overall, scores }) => {
  if (!open) return null;

  const formatLabel = (raw) => {
    if (!raw) return "";
    return String(raw)
      .replace(/([A-Z])/g, " $1")
      .replace(/_/g, " ")
      .split(" ")
      .filter(Boolean)
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
      .join(" ");
  };

  const toPct = (val) => {
    const num = Number(val);
    if (!Number.isFinite(num)) return 0;
    return Math.max(0, Math.min(100, (num / 10) * 100));
  };

  const toScoreOutOfTen = (val) => {
    const num = Number(val);
    if (!Number.isFinite(num)) return null;
    const clamped = Math.max(0, Math.min(10, num));
    return clamped;
  };

  const formatOutOfTen = (val) => {
    const score = toScoreOutOfTen(val);
    if (score === null) return "N/A";
    const text = Number.isInteger(score) ? String(score) : score.toFixed(1);
    return `${text}/10`;
  };

  const getBarColor = (val) => {
    const score = toScoreOutOfTen(val);
    if (score === null) return "var(--color-gray)";
    if (score <= 3) return "var(--color-danger)";
    if (score <= 7) return "var(--color-primary)";
    return "var(--color-success)";
  };

  const items = Object.entries(scores || {})
    .filter(([key, value]) => {
      const lowerKey = key.toLowerCase();
      if (
        lowerKey === "overall_score" ||
        lowerKey === "overallscore" ||
        lowerKey === "overall"
      ) {
        return false;
      }
      const num = Number(value);
      return Number.isFinite(num);
    })
    .map(([key, value]) => ({ key, value }));

  return createPortal(
    <div
      className="common-popup-overlay high-z-index eval-score-details-popup"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div
        className="common-popup-container eval-score-details-popup-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="popup-header with-close">
          <h2>Evaluate Details</h2>
          <button
            type="button"
            className="icon-button"
            onClick={onClose}
            aria-label="Close"
          >
            <CloseIcon fontSize="small" />
          </button>
        </div>

        <div className="popup-content eval-score-details-content">
          <div className="eval-score-card">
            <div className="eval-score-kpi">
              <div className="eval-score-kpi__label">Overall Score</div>
              <div className="eval-score-kpi__value">{formatOutOfTen(overall)}</div>
            </div>

            <div className="eval-score-breakdown">
              {items.map((it) => (
                <div key={it.key} className="eval-score-row">
                  <div className="eval-score-row__label">{formatLabel(it.key)}</div>
                  <div className="eval-score-row__bar">
                    <div
                      className="eval-score-row__barFill"
                      style={{
                        width: `${toPct(it.value)}%`,
                        background: getBarColor(it.value),
                      }}
                    />
                  </div>
                  <div className="eval-score-row__value">{formatOutOfTen(it.value)}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default EvalScoreDetailsPopup;
